var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container-fail flex flex-col justify-center items-center w-full h-full"},[_c('feather-icon',{staticClass:"image-read-error-icon",attrs:{"icon":"AlertCircleIcon"}}),_c('div',{staticClass:"image-read-error-message"},[_vm._v("\n    "+_vm._s(_vm.imageReadErrorMessage)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }